import { useEffect } from "react";

const TawkToChat = () => {
  useEffect(() => {
    var Tawk_API = window.Tawk_API || {}; 
    
    (function () {
      var s1 = document.createElement("script"),
        s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = "https://embed.tawk.to/67c24b21af3f52190befa755/1il7fauhi"; 
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");
      s0.parentNode.insertBefore(s1, s0);
    })();

    // Wait for the widget to load, then minimize
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_API.onLoad = function () {
      window.Tawk_API.minimize();
    };
  }, []);

  return null; // No UI element needed, just the script
};

export default TawkToChat;
